// extracted by mini-css-extract-plugin
export default {"root":"llY4YqZG8opXMvM2itn6","excludedLessonRow":"NSDUxrhhDyuCRaMSdaOL","excludedLessonLabel":"sr2gpvvdokSuSesstfTi","extraSmallRow":"dPFm4MQIFCcDGa4G3Tm6"};